var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{attrs:{"open-delay":"50"},scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-icon',{staticStyle:{"margin-top":"-9px"},attrs:{"color":hover ? 'black' : 'grey',"title":_vm.subscription,"medium":""},domProps:{"textContent":_vm._s('add')},on:{"click":_vm.eventClick}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }